// apiService.js
import axios from 'axios';
import { getAuthToken, getFacilityId, getcompanyId } from "../../utility/tokenUtility";
import { FemsGraph, BemsGraph, MasterGraph } from "../../utility/apiURLS";

export const deleteTC = async (id, type) => {
  try {
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    if (type === "FEMS") {
      const deleteFemsTC = await axios.delete(`${FemsGraph}/api/femtestingandcommissions/${id}`, config);
      return deleteFemsTC;
    } else {
      const deleteBemsTC = await axios.delete(`${BemsGraph}/api/bemtestingandcommissions/${id}`, config);
      return deleteBemsTC;
    }
  } catch (error) {
    console.log(error);
  }
}

export const getfemTCList = async (pageIndex, pageSize, filterModel, sortModel) => {
  try {
    const facilityid = getFacilityId("facilityId");
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(`${FemsGraph}/api/TestingAndCommission/GetTestingCommissionList/${facilityid}
    ?page=${pageIndex}&size=${pageSize}&filterOptions=${JSON.stringify(
      filterModel
    )}&sortOptions=${JSON.stringify(sortModel)}`,
      config);
    return response?.data;
  } catch (error) {
    console.log(error);
  }
}

export const getbemTCList = async (pageIndex, pageSize, filterModel, sortModel) => {
  try {
    const facilityid = getFacilityId("facilityId");
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(`${BemsGraph}/api/TestingAndCommission/GetTestingCommissionListbem/${facilityid}
    ?page=${pageIndex}&size=${pageSize}&filterOptions=${JSON.stringify(
      filterModel
    )}&sortOptions=${JSON.stringify(sortModel)}`,
      config);
    return response?.data;
  } catch (error) {
    console.log(error);
  }
}
export const getTCList = async () => {
  try {
    const facilityid = getFacilityId("facilityId");
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const [getfemTCList, getbemTCList] = await Promise.all([
      axios.get(`${FemsGraph}/api/TestingAndCommission/GetTestingCommissionList/${facilityid}?PageNumber=1&PageSize=100000`, config),
      axios.get(`${BemsGraph}/api/TestingAndCommission/GetTestingCommissionListbem/${facilityid}?PageNumber=1&PageSize=100000`, config)
    ]);

    const femsList = getfemTCList?.data;
    const bemsList = getbemTCList?.data;
    return { femsList, bemsList };

  } catch (error) {
    console.log(error);
  }
};

export const getfemExportList = async (filterModel, sortModel) => {
  try {
    const facilityid = getFacilityId("facilityId");
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(`${FemsGraph}/api/TestingAndCommission/GetExportData/${facilityid}
    ?&filterOptions=${JSON.stringify(
      filterModel
    )}&sortOptions=${JSON.stringify(sortModel)}`,
      config);
    return response?.data;
  } catch (error) {
    console.log(error);
  }
}

export const getbemExportList = async ( filterModel, sortModel) => {
  try {
    const facilityid = getFacilityId("facilityId");
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(`${BemsGraph}/api/TestingAndCommission/GetExportData/${facilityid}
    ?filterOptions=${JSON.stringify(
      filterModel
    )}&sortOptions=${JSON.stringify(sortModel)}`,
      config);
    return response?.data;
  } catch (error) {
    console.log(error);
  }
}

export const getTCListByID = async (id, type) => {
  try {
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
      if (type === "FEMS") {
      const response = await axios.get(`${FemsGraph}/api/TestingandCommission/GetTestinfandCommissionAllfems/${id}`, config);
    return [{ ...response?.data[0], purchaseprice: response?.data[0]?.purchaseprice?.toFixed(2) }]
    } else {
      const response = await axios.get(`${BemsGraph}/api/TestingandCommission/GetTestinfandCommissionAllbems/${id}`, config);
      return [{ ...response?.data[0], purchaseprice: response?.data[0]?.purchaseprice?.toFixed(2) }];
    }

  } catch (error) {
    console.log(error);
  }
};

export const getCriticalityOptions = async (type) => {
  try {
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    if (type === "FEMS") {
      const criticalOptions = await axios.get(`${FemsGraph}/api/femtestingriskstatuses?size=10000`, config);
      return criticalOptions?.data?.filter(item => item.isvisible);
    } else {
      const criticalOptions = await axios.get(`${BemsGraph}/api/bemtestingriskstatuses?size=10000`, config);
      return criticalOptions?.data?.filter(item => item.isvisible);;
    }
  } catch (error) {
    console.log("Error fetching department:", error);
  }
}

export const fetchMastersDetails = async () => {
  const facilityid = getFacilityId("facilityId");
  const companyId = getcompanyId("companyId");
  try {
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(`${MasterGraph}/api/masters/GetMasters/${companyId}/${facilityid}?size=10000`,config);
    return response?.data;
  } catch (error) {
    console.log("Error fetching department:", error);
  }
};
export const fetchlocationmasterDetails = async () => {
  const facilityid = getFacilityId("facilityId");
  const companyId = getcompanyId("companyId");
  try {
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(`${MasterGraph}/api/CommonExport/CommonExportData/${facilityid}/Location?page=1&size=5000&filterOptions=[]&sortOptions=[]`,config);
    return response?.data;
  } catch (error) {
    console.log("Error fetching department:", error);
  }
};

export const fetchVendorDetails = async () => {
  const companyId = getcompanyId('companyId');
  try {
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(`${MasterGraph}/api/GraphMaspomvendors/GetMaspomvendorsByFacilityId/${companyId}?size=10000`,config);
    return response?.data;
  } catch (error) {
    console.log("Error fetching Vendor details:", error);
  }
};

export const fetchWorkGroupDetails = async (service) => {
  const facilityid = getFacilityId("facilityId");
  try {
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    if (service === "FEMS") {
      const response = await axios.get(
        `${FemsGraph}/api/GraphWorkGroupDetails/GetWorkGroupDetailsByFacilityId/${facilityid}?size=10000`,
        config
      );
      return response?.data;
    } else {
      const response = await axios.get(
        `${BemsGraph}/api/GraphWorkGroupDetails/GetWorkGroupDetailsByFacilityId/${facilityid}?size=10000`,
        config
      );
      return response?.data;
    }
  } catch (error) {
    console.log("Error fetching workgroup details:", error);
  }
};

 export const fetchTypeCodeDetails = async (serviceId) => {
  try {
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const companyId = getcompanyId();
    const response = await axios.get(`${MasterGraph}/api/GraphMasassettypecode/GetMasassettypecodeServiceID/${serviceId},${companyId}?size=10000`, config);
    return response?.data
  } catch (error) {
    console.log("Error fetching workgroup details:", error);
  }
}

export const fetchHospitalDetails = async (facilityId) => {
  try {
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(`${MasterGraph}/api/GraphHospitalMaster/GetHospitalMasterByFacilityId/${facilityId}?size=1000`,config);
    return response?.data;
  } catch (error) {
    console.log("Error fetching workgroup details:", error);
  }
};

export const generateTCNumber = async (transactionCode) => {
  try {
    const token = getAuthToken("id_token");
    const facilityId = getFacilityId("facilityId");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.get(`${MasterGraph}/api/GraphDocumentSerialNumber/GetDocumentSerialNumberDetails/${facilityId}/${transactionCode}/${token}`, config);
    return response?.data;
  } catch (error) {
    console.log("Error fetching workgroup details:", error);
  }
};






